import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs/';

@Injectable()
export class PageLoaderService {
  private loaderStatus = new BehaviorSubject<boolean>(true);
  public obvStep: Observable<boolean> = this.loaderStatus.asObservable(); // convert to Observable for subscribing

  constructor() {
   }

  setPageLoaderStatus(value: boolean) {
    this.loaderStatus.next(value);
  }

  getPageLoaderStatus(): Observable<boolean> {
    return this.obvStep;
  }
}
